/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { productCategoryControllerCreate } from '../fn/product-category/product-category-controller-create';
import { ProductCategoryControllerCreate$Params } from '../fn/product-category/product-category-controller-create';
import { productCategoryControllerDelete } from '../fn/product-category/product-category-controller-delete';
import { ProductCategoryControllerDelete$Params } from '../fn/product-category/product-category-controller-delete';
import { productCategoryControllerFindByType } from '../fn/product-category/product-category-controller-find-by-type';
import { ProductCategoryControllerFindByType$Params } from '../fn/product-category/product-category-controller-find-by-type';
import { productCategoryControllerUpdate } from '../fn/product-category/product-category-controller-update';
import { ProductCategoryControllerUpdate$Params } from '../fn/product-category/product-category-controller-update';
import { productCategoryControllerUpdateOrder } from '../fn/product-category/product-category-controller-update-order';
import { ProductCategoryControllerUpdateOrder$Params } from '../fn/product-category/product-category-controller-update-order';
import { ProductCategoryDto } from '../models/product-category-dto';

@Injectable({ providedIn: 'root' })
export class ProductCategoryService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `productCategoryControllerFindByType()` */
  static readonly ProductCategoryControllerFindByTypePath = '/api/product-category/{type}';

  /**
   * Get categories by product type.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productCategoryControllerFindByType()` instead.
   *
   * This method doesn't expect any request body.
   */
  productCategoryControllerFindByType$Response(params: ProductCategoryControllerFindByType$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProductCategoryDto>>> {
    return productCategoryControllerFindByType(this.http, this.rootUrl, params, context);
  }

  /**
   * Get categories by product type.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productCategoryControllerFindByType$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productCategoryControllerFindByType(params: ProductCategoryControllerFindByType$Params, context?: HttpContext): Observable<Array<ProductCategoryDto>> {
    return this.productCategoryControllerFindByType$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ProductCategoryDto>>): Array<ProductCategoryDto> => r.body)
    );
  }

  /** Path part for operation `productCategoryControllerCreate()` */
  static readonly ProductCategoryControllerCreatePath = '/api/product-category';

  /**
   * Create category.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productCategoryControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  productCategoryControllerCreate$Response(params: ProductCategoryControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductCategoryDto>> {
    return productCategoryControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Create category.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productCategoryControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  productCategoryControllerCreate(params: ProductCategoryControllerCreate$Params, context?: HttpContext): Observable<ProductCategoryDto> {
    return this.productCategoryControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProductCategoryDto>): ProductCategoryDto => r.body)
    );
  }

  /** Path part for operation `productCategoryControllerUpdateOrder()` */
  static readonly ProductCategoryControllerUpdateOrderPath = '/api/product-category/order';

  /**
   * Bulk update category order.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productCategoryControllerUpdateOrder()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  productCategoryControllerUpdateOrder$Response(params: ProductCategoryControllerUpdateOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProductCategoryDto>>> {
    return productCategoryControllerUpdateOrder(this.http, this.rootUrl, params, context);
  }

  /**
   * Bulk update category order.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productCategoryControllerUpdateOrder$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  productCategoryControllerUpdateOrder(params: ProductCategoryControllerUpdateOrder$Params, context?: HttpContext): Observable<Array<ProductCategoryDto>> {
    return this.productCategoryControllerUpdateOrder$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ProductCategoryDto>>): Array<ProductCategoryDto> => r.body)
    );
  }

  /** Path part for operation `productCategoryControllerDelete()` */
  static readonly ProductCategoryControllerDeletePath = '/api/product-category/{id}';

  /**
   * Delete category.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productCategoryControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  productCategoryControllerDelete$Response(params: ProductCategoryControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return productCategoryControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete category.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productCategoryControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productCategoryControllerDelete(params: ProductCategoryControllerDelete$Params, context?: HttpContext): Observable<boolean> {
    return this.productCategoryControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `productCategoryControllerUpdate()` */
  static readonly ProductCategoryControllerUpdatePath = '/api/product-category/{id}';

  /**
   * Update category.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productCategoryControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  productCategoryControllerUpdate$Response(params: ProductCategoryControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductCategoryDto>> {
    return productCategoryControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Update category.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productCategoryControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  productCategoryControllerUpdate(params: ProductCategoryControllerUpdate$Params, context?: HttpContext): Observable<ProductCategoryDto> {
    return this.productCategoryControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProductCategoryDto>): ProductCategoryDto => r.body)
    );
  }

}
